import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { ESSENTIALS_ACCENT } from './billingPlanData';
import './PlanFeatureList.css';

function FeatureTooltip({ tip, id, label }) {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id={id}>{tip}</Tooltip>}>
      <button type="button" className="plan-feature-list__tooltip-icon" aria-label={`More about ${label}`}>
        <InfoCircle size={11} color="currentColor" aria-hidden />
      </button>
    </OverlayTrigger>
  );
}

/**
 * Single feature row for plan cards. Uses flex-start + min-width:0 so long labels wrap on mobile.
 */
export function PlanFeatureItem({
  label,
  included = true,
  accentColor = ESSENTIALS_ACCENT,
  tooltip,
  tooltipId,
  dimmed,
  labelColor,
  excludedMark = 'dash',
}) {
  const muted = dimmed ?? !included;
  const mark = included ? '✓' : excludedMark === 'x' ? '✕' : '—';

  return (
    <li
      className={`plan-feature-list__item${muted ? ' plan-feature-list__item--muted' : ''}`}
      {...(labelColor ? { 'data-themed': '' } : {})}
    >
      <span
        className={`plan-feature-list__mark${included ? '' : ' plan-feature-list__mark--x'}`}
        style={included ? { color: accentColor } : undefined}
        aria-hidden
      >
        {mark}
      </span>
      <span
        className="plan-feature-list__label"
        style={labelColor && !muted ? { color: labelColor } : undefined}
      >
        {label}
        {tooltip ? (
          <FeatureTooltip tip={tooltip} label={label} id={tooltipId || `plan-ft-${label.slice(0, 24)}`} />
        ) : null}
      </span>
    </li>
  );
}

export function PlanFeatureList({ children, size = 'md', className = '', style }) {
  const sizeClass = size === 'sm' ? 'plan-feature-list--sm' : 'plan-feature-list--md';
  return (
    <ul className={`plan-feature-list ${sizeClass} ${className}`.trim()} style={style}>
      {children}
    </ul>
  );
}
